export default __webpack_public_path__ + "static/media/no_data_found.b25d9d1f.png";